import { ErrorBoundary } from '@/components/ui';
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { MOBILE_GAMES, MobileGamePage, MobileGames } from './mobile-games';
import { MobileNavigation } from './mobile-navigation';
import { MobilePageContent } from './mobile-page-content';
import { MobilePortfolioContact } from './mobile-portfolio-contact';
import { MobilePortfolioAbout, MobilePortfolioHome, MobilePortfolioProjects } from './portfolio-components';

// Helper component to wrap mobile components with error boundary
const MobileRouteWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <ErrorBoundary
            fallback={
                <div className='min-h-screen bg-vscode-bg flex items-center justify-center p-4'>
                    <div className='text-center max-w-md mx-auto'>
                        <div className='text-vscode-error text-4xl mb-4'>⚠️</div>
                        <div className='text-vscode-text text-lg font-medium mb-2'>Error Loading Page</div>
                        <div className='text-vscode-text-muted text-sm mb-4'>
                            Something went wrong while loading this page. Please try refreshing the page.
                        </div>
                        <button
                            onClick={() => window.location.reload()}
                            className='px-4 py-2 bg-vscode-accent hover:bg-vscode-accent-secondary text-white rounded-lg transition-colors'
                        >
                            Refresh Page
                        </button>
                    </div>
                </div>
            }
        >
            {children}
        </ErrorBoundary>
    );
};

export const MobileRouter: React.FC = () => {
    return (
        <BrowserRouter>
            <div className='flex flex-col h-full min-h-0 overflow-hidden bg-vscode-bg text-vscode-text'>
                {/* Navigation Bar */}
                <MobileNavigation />

                {/* Main Content */}
                <MobilePageContent>
                    <Routes>
                        <Route
                            path='/Portfolio/index.html'
                            element={
                                <MobileRouteWrapper>
                                    <MobilePortfolioHome />
                                </MobileRouteWrapper>
                            }
                        />
                        <Route
                            path='/Portfolio/about.html'
                            element={
                                <MobileRouteWrapper>
                                    <MobilePortfolioAbout />
                                </MobileRouteWrapper>
                            }
                        />
                        <Route
                            path='/Portfolio/projects.html'
                            element={
                                <MobileRouteWrapper>
                                    <MobilePortfolioProjects />
                                </MobileRouteWrapper>
                            }
                        />
                        <Route
                            path='/Portfolio/contact.html'
                            element={
                                <MobileRouteWrapper>
                                    <MobilePortfolioContact />
                                </MobileRouteWrapper>
                            }
                        />
                        <Route
                            path='/Games'
                            element={
                                <MobileRouteWrapper>
                                    <MobileGames />
                                </MobileRouteWrapper>
                            }
                        />
                        {MOBILE_GAMES.map(game => (
                            <Route
                                key={game.id}
                                path={`/Games/${game.id}.html`}
                                element={
                                    <MobileRouteWrapper>
                                        <MobileGamePage game={game} />
                                    </MobileRouteWrapper>
                                }
                            />
                        ))}
                        <Route path='*' element={<Navigate to='/Portfolio/index.html' replace />} />
                    </Routes>
                </MobilePageContent>
            </div>
        </BrowserRouter>
    );
};
